import React, { useState } from 'react';
import { StyledModal, NpsFontFace } from './styles';
import { INpsSurveyModalProps } from './types';
import { SCORES } from './scores';

const NpsSurveyModal: React.FC<INpsSurveyModalProps> = ({
  visible,
  question,
  onClose,
  onDismiss,
  onSubmit,
  submitting,
}) => {
  const [score, setScore] = useState<number | null>(null);
  const [comment, setComment] = useState('');

  const handleSubmit = () => {
    if (score === null) return;
    onSubmit(score, comment);
  };

  return (
    <>
      <NpsFontFace />
      <StyledModal
      centered
      visible={visible}
      onCancel={onClose}
      width={820}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      maskStyle={{ background: 'rgba(15, 15, 18, 0.55)', backdropFilter: 'blur(1.5px)' }}
    >
      <div className="accent" />
      <button className="close" type="button" aria-label="Fechar" onClick={onDismiss}>
        ✕
      </button>
      <div className="content">
        <span className="brand">valori</span>
        <h2 className="question">{question}</h2>
        <div className="scores">
          {SCORES.map((s) => (
            <button
              key={s.value}
              className={`score${score === s.value ? ' selected' : ''}`}
              type="button"
              aria-label={`Nota ${s.value}`}
              aria-pressed={score === s.value}
              onClick={() => setScore(s.value)}
            >
              <span
                className="face"
                style={{ background: s.color, ['--ring' as string]: `${s.color}55` }}
              >
                <span className="eyes">
                  <span className="eye" />
                  <span className="eye" />
                </span>
                <span className={`mouth ${s.mood}`} />
              </span>
              <span className="score-number" style={{ color: s.color }}>
                {s.value}
              </span>
            </button>
          ))}
        </div>
        <div className="field">
          <label className="field-label" htmlFor="nps-justification">
            Justifique sua resposta <span className="optional">(opcional)</span>
          </label>
          <textarea
            className="justification"
            id="nps-justification"
            rows={2}
            placeholder="Conte pra gente o que motivou sua nota..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        <div className="actions">
          <button className="remind" type="button" onClick={onDismiss}>
            Responder depois
          </button>
          <button
            className="submit"
            type="button"
            disabled={score === null || submitting}
            onClick={handleSubmit}
          >
            Enviar avaliação
          </button>
        </div>
      </div>
      </StyledModal>
    </>
  );
};

export default NpsSurveyModal;
